import { Link, useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import * as XLSX from 'xlsx';
export const PageNotFound = ({ open, text }) => {
    return (
        <main id="main" className="main" style={open ? {} : { margin: "0", background:"#cbdfef", height:"100vh" }}>
            <section className="py-3">
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-12 mb-5">
                            <center>
                                <div className="thankyou-img">
                                    <img src="./assets/img/coming-soon.jpg" className="img-fluid" alt='' />
                                </div>
                                <div className="thankyou-text mt-3">
                                    {text ?
                                        <h2 className="main-heading h4">{text}</h2>
                                        :
                                        <h2 className="main-heading h4">Page Not Found !.</h2>
                                    }

                                    <p>We're working hard to give you the best experience!</p>
                                    <Link to="/" className="btn text-light mt-3" style={{ background: '#314cb5' }}>
                                        Back to Login
                                    </Link>
                                </div>
                            </center>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    )
}
export const ERRORDATALIST = (Status, FileName) => {
    const workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.aoa_to_sheet([
        (Object.keys(Status.ErrorData[0]))
        ,
        ...Status?.ErrorData?.map((records) =>
            Object.keys(Status.ErrorData[0])?.map((data, i) =>
                records[data]
            )
        ),
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, FileName);
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${FileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

}
export const HandleBulkInsertData = async (url, Records, data) => {
    let SuccessCount = 0;
    let ErrorData = [];
    let ErrorCount = 0;

    if (Records.length !== 0) {
        console.log(Records, "Records,Records");

        for (let i = 0; i < Records.length; i++) {
            let stringifiedRecord = {};

            // Convert each property to string or keep boolean as is
            for (const key in Records[i]) {
                if (Object.hasOwnProperty.call(Records[i], key)) {
                    const value = Records[i][key];

                    // Keep booleans as is, convert numbers to strings, and handle other types
                    if (typeof value === 'boolean') {
                        stringifiedRecord[key] = value; // Keep boolean
                    } else if (typeof value === 'number') {
                        stringifiedRecord[key] = value.toString(); // Convert number to string
                    } else {
                        stringifiedRecord[key] = value !== null ? value.toString() : ""; // Convert everything else to string
                    }
                }
            }

            let response = { ...data, ...stringifiedRecord };

            try {
                const resp = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(response),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                const res = await resp.json();
                if (res.status === "SUCCESS") {
                    SuccessCount++;
                } else if (res.status === 'ERROR') {
                    ErrorData.push({ ...Records[i], ERROR: res.message });
                    console.log(ErrorData, 'tttttttttttt');
                    ErrorCount++;
                }
            } catch (error) {
                console.error("Error during fetch:", error);
                ErrorData.push({ ...Records[i], ERROR: "Fetch failed" });
                ErrorCount++;
            }
        }
    } else {
        alert('No Record Found !');
    }

    return { SuccessCount, ErrorCount, ErrorData };
};


export const DownloadFileAtURL = (file) => {
    const filePath = `/${file}`;
    const fileName = file.split('/').pop();

    fetch(filePath)
        .then(response => {
            if (response.status !== 200) {
                throw new Error('File not found');
            }
            console.log(response, '2313')
            return response.blob();
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const aTag = document.createElement('a');
            aTag.href = url;
            aTag.setAttribute('download', fileName);
            document.body.appendChild(aTag);
            aTag.click();
            aTag.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading the file:', error);
            alert('Unable to download the file. Please check the file path.');
        });
}
export const readFile = async (e) => {
    const file = e
    let FileName = (e.name);
    const data = await file.arrayBuffer(file)
    const excelFile = XLSX.read(data)
    const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]]
    const exceljson = XLSX.utils.sheet_to_json(excelSheet)

    return { exceljson, FileName }
}
export const BulkClearData = () => {
    let a = document.querySelectorAll('.jRuVVs');
    if (a.length > 0) {
        a[0].innerHTML = 'Upload  or drop a file right here'
        a[0].innerHTML = a[0].innerHTML.replace('Upload', '<span className="text-decoration-underline">Upload</span>');
    }
}
//export const readFile = async (e) => {
//    const file = e;
//    let FileName = e.name;
//    const data = await file.arrayBuffer(file);
//    const excelFile = XLSX.read(data);
//    const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]];
//    const exceljson = XLSX.utils.sheet_to_json(excelSheet, {
//        defval: "",
//        raw: false,
//        header: 0
//    });
//    // Function to convert text to boolean
//    const textToBoolean = (text) => {
//        const lowerText = text.toLowerCase();
//        if (lowerText === "true") {
//            return true;
//        } else if (lowerText === "false") {
//            return false;
//        }
//        return null;
//    };
//    for (let i = 0; i < exceljson.length; i++) {
//        const row = exceljson[i];
//        for (const key in row) {
//            if (row.hasOwnProperty(key)) {
//                const value = row[key];
//                if (typeof value === "string") {
//                    const booleanValue = textToBoolean(value);
//                    if (booleanValue !== null) {
//                        row[key] = booleanValue;
//                    }
//                }
//            }
//        }
//    }

//    return { exceljson, FileName };
//};
export const FileUploadChild = (props) => {
    const { label = '', message = '', types = [], children } = props;
    return (
        <>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z" fill="#0658C2"></path><path d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z" fill="#0658C2"></path><path d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z" fill="#0658C2"></path></svg>
            <div className="sc-eqUAAy file-children">
                {(message.trim() === '.' || message.trim() === '') ?
                    <span className="sc-fqkvVR"><span>{`${('Upload')} ${label}`}</span>{('or drop a file right here')} </span> :
                    <span className="sc-fqkvVR"><span className='text-success'>{`${message}`}</span>{('uploaded successfully!')}</span>
                }
                {(message.trim() !== '.' || message.trim() !== '') &&
                    <span title={`types: ${types.join()}`} className="file-types text-info">{types.join()}</span>
                }
                {children}
            </div>
        </>
    );
}
export const ClearSession = () => {
    const cookies = new Cookies();
    const navigate = useNavigate()
    cookies.remove('token')
    cookies.remove('loginUserCode')
    cookies.remove('userName')
    cookies.remove('CookieConsentByFineshop')
    cookies.remove('csrftoken')
    setTimeout(() => {
        navigate('/login');
    }, 1000)
}